import React from 'react';

const Services = ({ language = 'en' }) => {
  const content = {
    en: {
      title: 'Services That We Provide',
      subtitle: 'Comprehensive Solutions For Smart Estate Management',
      services: [
        {
          number: '01',
          category: 'EV Infrastructure',
          title: 'EV Chargers & Digital Payment System',
          description: 'Comprehensive EV charging solutions with integrated payment systems supporting Octopus, mobile wallets, and dedicated apps for seamless plug & charge experience.',
          link: '#ev-chargers'
        },
        {
          number: '02',
          category: 'Cloud Technology',
          title: 'Cloud & Central Management System',
          description: 'Advanced cloud-based management platform with real-time monitoring, remote control, and dynamic load balancing for your EV charging network.',
          link: '#ev-cloud-management'
        },
        {
          number: '03',
          category: 'Property Management',
          title: 'Management Fee Collection System',
          description: 'Automated property management fee system with multiple payment methods, automatic reminders, and real-time financial reporting for residential and commercial buildings.',
          link: '#property-management'
        },
        {
          number: '04',
          category: 'Digital Communication',
          title: 'Electronic Notification System',
          description: 'Smart digital notification system replacing traditional paper notices with multi-channel delivery, carousel displays, and read receipt tracking.',
          link: '#enotice-system'
        },
        {
          number: '05',
          category: 'AI Marketing',
          title: 'AI Smart Marketing & Digital Screen',
          description: 'AI-powered smart marketing solutions with digital screen networks, intelligent content creation, precise advertising, and real-time data monitoring.',
          link: '#ai-marketing'
        }
      ]
    },
    zh: {
      title: '我們提供的服務',
      subtitle: '智慧物業管理綜合解決方案',
      services: [
        {
          number: '01',
          category: '電動車基建',
          title: '電動車充電及付款系統',
          description: '全面的電動車充電解決方案，整合支付系統，支援八達通、手機錢包及專屬應用程式，提供無縫即停即充體驗。',
          link: '#ev-chargers'
        },
        {
          number: '02',
          category: '雲端技術',
          title: '雲端及中央管理系統',
          description: '先進的雲端管理平台，具備實時監控、遠程控制及動態負載平衡功能，全面管理您的電動車充電網絡。',
          link: '#ev-cloud-management'
        },
        {
          number: '03',
          category: '物業管理',
          title: '管理費收費系統',
          description: '自動化物業管理費系統，支援多種付款方式、自動提醒及實時財務報表，適用於住宅及商業大廈。',
          link: '#property-management'
        },
        {
          number: '04',
          category: '數字通訊',
          title: '電子通告系統',
          description: '智能電子通告系統取代傳統紙本通知，提供多渠道發送、輪播展示及已讀回執追蹤功能。',
          link: '#enotice-system'
        },
        {
          number: '05',
          category: 'AI營銷',
          title: 'AI智能營銷與電子屏幕',
          description: 'AI驅動的智能營銷方案，結合電子屏幕網絡、智能內容製作、精準廣告投放及實時數據監測。',
          link: '#ai-marketing'
        }
      ]
    }
  };

  const currentContent = content[language] || content.en;

  return (
    <section id="services" className="service__section overhid pt-120 pb-120">
      <div className="container">
        <div className="project__head text-center">
          <span className="common__sub aos-init aos-animate" data-aos="fade-down" data-aos-duration="1000">
            {currentContent.title}
          </span>
          <h2 className="fw-500 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" style={{ color: '#c9f31d' }}>
            {currentContent.subtitle}
          </h2>
        </div>

        <div className="service__uniquewrap">
          {currentContent.services.map((service, index) => (
            <div 
              key={index}
              className="service__unique__item pb-40 pt-40 aos-init aos-animate" 
              data-aos="fade-up" 
              data-aos-duration="1000"
              data-aos-delay={index * 100}
            >
              <div className="left__service">
                <div className="serial__adjust">
                  <span> {service.number} </span>
                  <div className="cont">
                    <h5>{service.category}</h5>
                    <h2>
                      <a href={service.link}> {service.title} </a>
                    </h2>
                  </div>
                </div>
                <p className="pra">{service.description}</p>
              </div>
              <a className="common__icon" href={service.link}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" className="i">
                  <path fillRule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"></path>
                </svg>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
